import { render } from "./AuthorizedImage.vue?vue&type=template&id=d3580cd8"
import script from "./AuthorizedImage.vue?vue&type=script&lang=js"
export * from "./AuthorizedImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__